import api from "@/lib/api";
import type {
  Client,
  ClientCreate,
  ClientUpdate,
} from "@/types/clients/api-types/client-types";
import type { PaginatedResponse } from "@/types/common/api-types";

export const clientsApi = {
  getAll: async (params?: {
    page?: number;
    size?: number;
    first_name?: string;
    last_name?: string;
    staff_id?: number;
  }): Promise<PaginatedResponse<Client>> => {
    const response = await api.get<PaginatedResponse<Client>>("/clients", {
      params,
    });
    return response.data;
  },

  getById: async (id: number): Promise<Client> => {
    const response = await api.get<Client>(`/clients/${id}`);
    return response.data;
  },

  create: async (data: ClientCreate): Promise<Client> => {
    const response = await api.post<Client>("/clients", data);
    return response.data;
  },

  update: async (id: number, data: ClientUpdate): Promise<Client> => {
    const response = await api.put<Client>(`/clients/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/clients/${id}`);
  },
};
